// extracted by mini-css-extract-plugin
module.exports = {"smart-tv":"smart-tv_smart-tv__xU7we","samsung":"smart-tv_samsung__wjMzh","lg":"smart-tv_lg__YnJWA"};